export default __webpack_public_path__ + "static/media/container.b321ed7a.png";